import { QueryEntity } from '@datorama/akita';
import { GeometricFormState } from './geometric-form.state';
import { GeometricFormType } from './geometric-form.type';

export abstract class GeometricFormQuery<T> extends QueryEntity<GeometricFormState, T, number> {

  isVisible$ = this.select(state => state.ui.visible);

  abstract type: GeometricFormType;
  isLoading$ = this.selectLoading();

  getUI() {
    return this.store.getValue().ui;
  }

}
